import styled from 'styled-components';

import ButtonComponent from '@r1-frontend/ui-react/components/buttons/button';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Button = styled(ButtonComponent)<{ isMobileView: boolean }>`
    padding: 12px 24px;
    ${FONTS.XS};
    width: 100%;
`;

export const Anchor = styled('a')`
    width: 100%;
`;
